import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Dry run behavior setting for cancellation fee handling.
 */
export const schema = z.enum(['default-off', 'default-on', 'forced-off', 'forced-on']);

export type DryRunBehavior = z.infer<typeof schema>;

export const definition = define({
  key: 'dry_run_behavior',
  schema,
  label: 'Dry Run Behavior',
  description:
    'Choose the behavior around dry run cancellations through move outcome. When a dry run is applied to a move, this will charge the ar cost of a move to the customer for cancellations instead of using the cancellation fee.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 'default-off',
});
